import React from "react"
import _ from "lodash"
import {NavLink as Link} from "react-router-dom"
import {List, ListItem} from "material-ui/List"
import Divider from "material-ui/Divider"
import * as Util from "../common"
import {containers} from "@swarm2/core"

const M = Util.intlMessages("view.UnitNav")
const UM = Util.intlMessages("units")

function UnitNavItemRender(props) {
  if (props.isEmpty) return null // don't show 404 for invisible items
  if (props.isError) return <Util.Error inline error={props} />
  const {unitName, url, count, velocity, cost, mode, isVisible} = props
  if (!isVisible) return null
  return (
    <ListItem
      className="navMenuItem"
      style={{textTransform: "capitalize"}}
      containerElement={<Link activeClassName="navLinkActive" to={url} />}
      primaryText={
        <div>
          <UM id={unitName + ".plural"} values={{count: 0}} />
        </div>
      }
      secondaryText={
        <span style={{color: "inherit"}}>
          <Util.Num val={count} />
          <br />
          {mode === "velocity" ? (
            <span>
              +<Util.Num val={velocity} />/sec
            </span>
          ) : null}
          {mode === "cost" && cost ? (
            <span>
              -<Util.Num val={cost} /> (<Util.Percent
                val={Math.min(
                  999.99,
                  count.isZero()
                    ? Number.POSITIVE_INFINITY
                    : cost.dividedBy(count).toNumber(),
                )}
              />)
            </span>
          ) : null}
        </span>
      }
      secondaryTextLines={2}
    />
  )
}
export const UnitNavItem = containers.units.UnitNavItem(UnitNavItemRender)

function UnitNavRender(props) {
  if (props.isError) return <Util.Error error={props} />
  const {charId, readonly, unitName, buyN, names} = props
  const url = (readonly ? "/c/" : "/p/") + charId + "/units"
  return (
    <List>
      {_.map(names, name => (
        <UnitNavItem
          key={name}
          charId={charId}
          parentUnitName={unitName}
          unitName={name}
          buyN={buyN}
          url={url + "/" + name}
        />
      ))}
      <Divider />
      <ListItem
        className="navMenuItem"
        style={{textTransform: "capitalize"}}
        containerElement={
          <Link exact activeClassName="navLinkActive" to={url} />
        }
        primaryText={<M id={"allunits"} />}
      />
    </List>
  )
}
export default containers.units.UnitNav(UnitNavRender)



// WEBPACK FOOTER //
// ./src/units/UnitNavView.js